<template>
  <div class=" ">
    <div class="font-bold text-2xl text-center">
        FastMoney - cần tiền vay liền, có tiền dùng ngay
    </div>
    <div class="">
       
        <div v-if="!show" class="mx-auto ">
             <div class="font-bold">
                FastMoney là gì?
            </div>
            Vay nhanh - FastMoney là thương hiệu thuộc Công ty Tài chính Cổ phần Điện lực 
            <span class="text-black text-opacity-75"> (được biết đến với thương hiệu vay tiêu dùng Easy Credit), </span>
            <span class="text-black text-opacity-50"> kết hợp với công ty cung cấp dịch vụ Amber Fintech 
                 cung cấp sản phẩm cho vay tiêu dùng cho khách hàng trên nền tảng ứng dụng Ví MoMo. </span>
            <span class="text-black text-opacity-25"> Với những ưu điểm vượt trội, FastMoney đem đến trải nghiệm dịch vụ tốt nhất và thuận tiện nhất khi khách hàng có nhu cầu vay tiêu dùng tín chấp. </span>

            <div class="text-center mt-4">
                <span @click="show = true" class="  color-main2 bactive p-2 rounded-2xl hover:text-red-500 hover:border-2 cursor-pointer"><b-icon icon="arrow-down" scale="1" ></b-icon> Xem thêm</span>
            </div>
        </div>

        <div v-else>
            <div id="section-html" class="mb-5 text-center md:mb-8">
            </div>
            <div class="mx-auto ">
            <div class="soju__prose small mt-5">
            <h3 class="h4">FastMoney l&agrave; g&igrave;?</h3>
            <p>Vay nhanh - FastMoney l&agrave; thương hiệu thuộc C&ocirc;ng ty T&agrave;i ch&iacute;nh Cổ phần Điện lực (được biết đến với thương hiệu vay ti&ecirc;u d&ugrave;ng&nbsp;<strong>Easy Credit</strong>), kết hợp với c&ocirc;ng ty cung cấp dịch vụ&nbsp;<strong>Amber Fintech</strong>&nbsp;cung cấp sản phẩm cho vay ti&ecirc;u d&ugrave;ng cho kh&aacute;ch h&agrave;ng tr&ecirc;n nền tảng ứng dụng&nbsp;<strong>V&iacute; MoMo</strong>. Với những ưu điểm vượt trội, FastMoney đem đến trải nghiệm dịch vụ tốt nhất v&agrave; thuận tiện nhất khi kh&aacute;ch h&agrave;ng c&oacute; nhu cầu vay ti&ecirc;u d&ugrave;ng t&iacute;n chấp.</p>
            <h3 class="h4">Đặc quyền khi chọn vay nhanh - FastMoney</h3>
            <p>FastMoney gần như giải quyết triệt để những hạn chế trong c&aacute;c t&igrave;nh huống vay một khoản tiền nhỏ, nhưng gặp trở ngại li&ecirc;n quan đến thủ tục hay thời gian giải ng&acirc;n.</p>
            <p>Chỉ với một chạm tr&ecirc;n V&iacute; MoMo, mở ngay &ldquo;lối tắt" nhanh gọn gi&uacute;p bạn vay trực tuyến m&agrave; chẳng cần một bước di chuyển!</p>
            <ul>
            <li><strong>G&oacute;i vay đa dạng:</strong>&nbsp;Cung cấp g&oacute;i vay từ 2 triệu đến 20 triệu với kỳ hạn thanh to&aacute;n l&ecirc;n đến 7 th&aacute;ng v&agrave; l&atilde;i suất cạnh tranh.</li>
            <li><strong>Trả g&oacute;p từng kỳ:</strong>&nbsp;Cho ph&eacute;p kh&aacute;ch h&agrave;ng thanh to&aacute;n khoản vay từng kỳ.</li>
            <li><strong>Hồ sơ đơn giản:</strong>&nbsp;Kh&ocirc;ng cần thủ tục giấy tờ phức tạp, kh&ocirc;ng cần chứng minh thu nhập.</li>
            <li><strong>Duyệt nhanh:</strong>&nbsp;Duyệt nhanh trong 1 ph&uacute;t.</li>
            <li><strong>Giải ng&acirc;n nhanh:</strong>&nbsp;Nhận giải ng&acirc;n về V&iacute; MoMo ngay sau khi được duyệt vay.</li>
            <li><strong>Tin cậy, bảo mật:</strong>&nbsp;Đơn vị cho vay uy t&iacute;n, bảo mật th&ocirc;ng tin.</li>
            </ul>
            <h3 class="h4">Hướng dẫn đăng k&yacute; vay FastMoney tr&ecirc;n MoMo</h3>
            <p><strong>Bước 1:</strong>&nbsp;Tại m&agrave;n h&igrave;nh ch&iacute;nh, chọn dịch vụ T&agrave;i Ch&iacute;nh - Bảo Hiểm, sau đ&oacute; chọn Vay Nhanh - FastMoney; hoặc nhập từ kh&oacute;a &ldquo;FastMoney&rdquo; v&agrave;o &ocirc; T&igrave;m kiếm.</p>
            <p><strong>Bước 2:</strong>&nbsp;Lựa chọn khoản vay v&agrave; thời hạn thanh to&aacute;n ph&ugrave; hợp</p>
            <p><strong>Bước 3:</strong>&nbsp;Đăng k&yacute; th&ocirc;ng tin</p>
            <p><strong>Bước 4:</strong>&nbsp;X&aacute;c nhận th&ocirc;ng tin v&agrave; đăng k&yacute; vay</p>
            <p><strong>Bước 5:</strong>&nbsp;Chờ ph&ecirc; duyệt trong v&ograve;ng 1&nbsp;ph&uacute;t</p>
            <p><strong>Bước 6:</strong>&nbsp;Nhận m&atilde; OTP v&agrave; k&yacute; hợp đồng bằng c&aacute;ch điền m&atilde; OTP</p>
            <p><strong>Bước 7:</strong>&nbsp;Nhận giải ng&acirc;n về V&iacute; MoMo</p>
            <h3 class="h4">Điều kiện đăng k&yacute; khoản vay</h3>
            <ul>
            <li>L&agrave; kh&aacute;ch h&agrave;ng sử dụng V&iacute; điện tử MoMo đ&atilde; x&aacute;c thực.</li>
            <li>Nằm trong danh s&aacute;ch kh&aacute;ch h&agrave;ng được sử dụng sản phẩm Vay nhanh - FastMoney.</li>
            </ul>
            <h3 class="h4">Đối t&aacute;c uy t&iacute;n, đ&aacute;ng tin cậy</h3>
            <p>FastMoney l&agrave; sản phẩm t&agrave;i ch&iacute;nh với sự hợp t&aacute;c của c&aacute;c b&ecirc;n:</p>
            <p>- C&ocirc;ng ty T&agrave;i ch&iacute;nh Cổ phần Điện lực &ndash; EVN Finance: L&agrave; đơn vị cung cấp sản phẩm vay.</p>
            <p>- C&ocirc;ng ty cổ phần Amber Fintech: L&agrave; đơn vị cung cấp nền tảng c&ocirc;ng nghệ ph&acirc;n t&iacute;ch đ&aacute;nh gi&aacute; v&agrave; quản l&yacute; kh&aacute;ch h&agrave;ng.</p>
            <p>- C&ocirc;ng ty Hệ thống th&ocirc;ng tin FPT: L&agrave; đơn vị cung cấp chữ k&yacute; số, cho ph&eacute;p b&ecirc;n vay v&agrave; b&ecirc;n cho vay k&yacute; hợp đồng điện tử trực tiếp tr&ecirc;n điện thoại di động.</p>
            <p>Bạn đang gặp kh&oacute; khăn về t&agrave;i ch&iacute;nh v&agrave; cần một khoản tiền gấp để trang trải chi ti&ecirc;u trong m&ugrave;a dịch? Đăng k&yacute; ngay Vay nhanh &ndash; Fast Money nh&eacute;! Với th&ocirc;ng tin đ&atilde; được v&iacute; MoMo x&aacute;c thực th&igrave; việc đăng k&yacute; v&agrave; nhận tiền v&ocirc; c&ugrave;ng dễ d&agrave;ng gi&uacute;p bạn giải quyết nhu cầu t&agrave;i ch&iacute;nh cấp b&aacute;ch. Ch&uacute;c c&aacute;c bạn đăng k&yacute; vay th&agrave;nh c&ocirc;ng!</p>
            <h3 class="h4">Th&ocirc;ng tin li&ecirc;n hệ để được hỗ trợ</h3>
            <p>Hotline: 1900 6383 98 | 8:30 - 22:00 (Thứ 2 - Thứ 6)</p>
            <p>Email: info@easycredit.vn</p>
            </div>
            </div>
            <div class="text-center mt-4">
                <span @click="show = false" class="  color-main2 bactive p-2 rounded-2xl hover:text-red-500 hover:border-2 cursor-pointer"><b-icon icon="arrow-up" scale="1" ></b-icon> Thu gọn</span>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
            show: false
        }
    },
}
</script>

<style>
ul { 
   list-style-type: disc; 
   list-style-position: inside; 
}
ol { 
   list-style-type: decimal; 
   list-style-position: inside; 
}
ul ul, ol ul { 
   list-style-type: circle; 
   list-style-position: inside; 
   margin-left: 15px; 
}
ol ol, ul ol { 
   list-style-type: lower-latin; 
   list-style-position: inside; 
   margin-left: 15px; 
}


</style>